<template>
  <div
    id="contentWrapper"
    class="content-wrapper"
  >
    <j-information-view
      v-if="menu === 'information'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
    <j-table-view
      v-else-if="menu === 'table'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-table-req-view
      v-else-if="menu === 'table-requestor'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-table-app-view
      v-else-if="menu === 'table-approver'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-list-view
      v-else-if="menu === 'list'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-list-req-view
      v-else-if="menu === 'list-requestor'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-list-app-view
      v-else-if="menu === 'list-approver'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-calendar-view
      v-else-if="menu === 'calendar'"
      :is-multiple-form="isMultipleForm"
      :form-detail="formDetail"
    />
    <j-create-view
      v-else-if="menu === 'create'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
    <j-detail-view
      v-else-if="!isMultipleForm && menu === 'detail'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
    <j-multiple-detail-view
      v-else-if="isMultipleForm && menu === 'detail'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
    <j-import-view
      v-else-if="menu === 'import'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
    <j-export-view
      v-else-if="menu === 'export'"
      :is-multiple-form="isMultipleForm"
      :form-data="formData"
      :form-detail="formDetail"
    />
  </div>
</template>

<script>
// View
import jInformationView from '@/views/experience-manager-v2/menu/jInformationView';
import jTableView from '@/views/experience-manager-v2/menu/jTableView';
import jTableReqView from '@/views/experience-manager-v2/menu/jTableReqView';
import jTableAppView from '@/views/experience-manager-v2/menu/jTableAppView';
import jListView from '@/views/experience-manager-v2/menu/jListView';
import jListReqView from '@/views/experience-manager-v2/menu/jListReqView';
import jListAppView from '@/views/experience-manager-v2/menu/jListAppView';
import jCalendarView from '@/views/experience-manager-v2/menu/jCalendarView';
import jCreateView from '@/views/experience-manager-v2/menu/jCreateView';
import jDetailView from '@/views/experience-manager-v2/menu/jDetailView';
import jMultipleDetailView from '@/views/experience-manager-v2/menu/jMultipleDetailView';
import jImportView from '@/views/experience-manager-v2/menu/jImportView';
import jExportView from '@/views/experience-manager-v2/menu/jExportView';

export default {
  components: {
    // View
    jInformationView,
    jTableView,
    jTableReqView,
    jTableAppView,
    jListView,
    jListReqView,
    jListAppView,
    jCalendarView,
    jCreateView,
    jDetailView,
    jMultipleDetailView,
    jImportView,
    jExportView,
  },

  props: {
    formDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    menu: {
      type: String,
      default: 'information',
    },
    isMultipleForm: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/jExperienceManagerViewContent.vue